import { render, staticRenderFns } from "./OutboundAdd.vue?vue&type=template&id=6b3c1fda&scoped=true"
import script from "./OutboundAdd.vue?vue&type=script&lang=js"
export * from "./OutboundAdd.vue?vue&type=script&lang=js"
import style0 from "./OutboundAdd.vue?vue&type=style&index=0&id=6b3c1fda&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3c1fda",
  null
  
)

export default component.exports